import React from "react";
import { ResponsivePie } from "@nivo/pie";

/**
 * OwnershipDonutNivo.jsx
 * - ownershipData.json을 기반으로 Nivo 도넛 차트를 렌더링
 */

const DEFAULT_DATA = [
  { id: "default-1", label: "A그룹", value: 25, color: "#0E3B6F" },
  { id: "default-2", label: "B그룹", value: 25, color: "#0D4FBF" },
  { id: "default-3", label: "C그룹", value: 25, color: "#2E66C5" },
  { id: "default-4", label: "기타", value: 25, color: "#9DD6EC" },
];

export default function OwnershipDonutNivo({
  data = DEFAULT_DATA,
  height = 300,
  innerRadius = 0.55,
  centerLabel,
  showLegend = false,
}) {
  const chartData = data.map((item, idx) => ({
    ...item,
    id: item.id || item.label || `segment-${idx}`,
    label: item.label,
    value: Number(item.value) || 0,
    color: item.color,
  }));

  return (
    <div className="ownership-chart">
      <div className="ownership-chart__canvas ownership-chart__canvas--desktop">
        <ResponsivePie /* or Pie for fixed dimensions */
          data={chartData}
          margin={{ top: 20, right: 200, bottom: 20, left: 20 }}
          innerRadius={0.5}
          padAngle={0.6}
          cornerRadius={2}
          activeOuterRadiusOffset={8}
          enableArcLabels={false}
          enableArcLinkLabels={false}
          theme={{
            legends: {
              text: { fontSize: 15 },
            },
          }}
          legends={[
            {
              anchor: "right",
              direction: "column",
              translateX: 50,
              itemWidth: 220,
              itemHeight: 24,
              itemTextColor: "var(--c-text-primary)",
              itemsSpacing: 8,
              symbolSize: 10,
              symbolShape: "circle",
            },
          ]}
        />
      </div>
      <div className="ownership-chart__canvas ownership-chart__canvas--mobile">
        <ResponsivePie /* or Pie for fixed dimensions */
          data={chartData}
          margin={{ top: 20, right: 20, bottom: 0, left: 20 }}
          innerRadius={0.5}
          padAngle={0.6}
          cornerRadius={2}
          activeOuterRadiusOffset={8}
          enableArcLabels={false}
          enableArcLinkLabels={false}
        />
      </div>
      <div className="ownership-chart__legend">
        {chartData.map((item) => (
          <div key={item.id} className="ownership-chart__legend-item">
            <span
              aria-hidden="true"
              className="ownership-chart__legend-swatch"
              style={{ backgroundColor: item.color }}
            />
            <span className="ownership-chart__legend-label">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
